import {React} from 'common'
import {validationPatterns} from 'constants/auth'
import {useI18n} from 'store/Store'
import {FormCheckbox, FormContainer, FormTitle} from 'components/Control/Form'
import FormTextInput from 'components/Control/Form/FormTextInput'
import styled from 'styled-components'
import {Texts} from 'appearance'
import FormAutoComplete from 'components/Control/Form/FormAutoComplete.js'
import FormSwitch from 'components/Control/Form/FormSwitch.js'

const RegisterForm = ({
    control,
    errors,
    choreographersNames,
    isRegisterInMarkid,
}) => {
    const {i18n} = useI18n()
    const t = (label) => i18n.t('welcome.' + label)
    const description = t('attention')

    return (
        <FormContainer>
            <FormTitle>{t('welcome')}</FormTitle>
            <Description>{description}</Description>
            <FormSwitch
                name="isMarkid"
                control={control}
                label={t('isRegisteredInMarkid')}
            />
            <FormTextInput
                name="firstName"
                label={t('firstName')}
                control={control}
                rules={{
                    required: true,
                }}
                fullWidth
                type="text"
                initialValue=""
                errors={errors}
            />
            <FormTextInput
                name="lastName"
                label={t('lastName')}
                control={control}
                rules={{
                    required: true,
                }}
                fullWidth
                type="text"
                initialValue=""
                errors={errors}
            />
            {isRegisterInMarkid ? (
                <FormAutoComplete
                    name="markidName"
                    label={t('markidName')}
                    control={control}
                    rules={{
                        required: true,
                    }}
                    fullWidth
                    type="text"
                    initialValue=""
                    errors={errors}
                    options={choreographersNames}
                />
            ) : (
                <FormTextInput
                    name={'email'}
                    control={control}
                    rules={{
                        required: true,
                        pattern: validationPatterns.EMAIL,
                    }}
                    fullWidth
                    label={t('email')}
                    type="email"
                    errors={errors}
                />
            )}
            <FormTextInput
                name={'password'}
                control={control}
                rules={{
                    required: true,
                }}
                fullWidth
                initialValue=""
                label={t('password')}
                type="password"
                errors={errors}
            />
            <FormTextInput
                name={'confirmPassword'}
                control={control}
                rules={{
                    required: true,
                }}
                fullWidth
                initialValue=""
                label={t('confirmPassword')}
                type="password"
                errors={errors}
            />
            <FormCheckbox
                name={'rememberMe'}
                control={control}
                label={t('rememberMe')}
            />
        </FormContainer>
    )
}

export default RegisterForm

const Description = styled(Texts.MediumText)``
